require('./OKHeaderSubPageDetails.scss')

import React from 'react';
import PropTypes from 'prop-types';

const OKHeaderSubPageDetails = ({children}) => {
    
    return (
        <div className="ok-header-subpage-details">
            <div className="ok-header-subpage-details__inner">
                {children}
            </div>
        </div>
    )
}

OKHeaderSubPageDetails.propTypes = {
    children: PropTypes.element,
    isSubPageOneLine: PropTypes.bool
}

OKHeaderSubPageDetails.defaultProps = {
    isSubPageOneLine: true
}

export { OKHeaderSubPageDetails }